import React, { useEffect, useState, useRef } from 'react';
import { observer } from 'mobx-react';
import { init } from 'echarts';

import Color from '@/tool/color';
import { cityAreaarr, geoCoordMap } from '../../component/city';
import moCompanyDistribution, { changeActive, getCurrentArea, getCurrentCity, getCurrentRegion } from './store';

interface IProps { }
interface IState { }

const CityMap = (props: IProps, state: IState) => {
  const { type, distributList } = moCompanyDistribution;
  const talentMap = useRef<any>(null);
  const getDataList = distributList?.map((item: any) => {
    const items: any = {};
    items.name = item.city;
    items.value = item.amount;
    return items;
  });

  const getColorchange = () => {
    return cityAreaarr?.map((item: any) => {
      const items: any = {};
      distributList?.forEach((res: any) => {
        if (item.area === res.city) {
          items.name = item.name;
          items.value = res.amount;
        }
      });
      return items;
    });
  };

  const render = () => {
    const Ttalend = init(talentMap.current);

    let data: any = [];
    if (type === 'city') data = getDataList;
    else if (type === 'city_grade') {
      const result: any = [];
      distributList?.forEach((item: any) => {
        item?.city_list?.forEach((res: any) => {
          result.push({ name: res, value: item.amount });
        });
      });
      data = result;
    }

    const convertData = (data: string | any[]) => {
      const res = [];
      for (let i = 0; i < data?.length; i += 1) {
        const geoCoord = geoCoordMap[data[i].name];
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value),
          });
        }
      }
      return res;
    };

    const option = {
      // backgroundColor: Color.white,
      tooltip: {
        trigger: 'item',
        formatter(params: any) {
          const result: any = [];
          distributList?.forEach(((item: any) => {
            result.push(item.city);
          }));
          if (!result.includes(params.name)) {
            return '';
          }
          return `${params.name} : ${params.value[2]}`;
        },
        textStyle: {
          fontFamily: 'PingFang SC',
        },
      },
      legend: {
        data: [],
      },
      visualMap: {
        min: 0,
        max: 200,
        left: 20,
        bottom: 20,
        calculable: true,
        text: ['高', '低'],
        inRange: {
          color: [
            Color.primaryColor(0.5),
            Color.primaryColor(0.55),
            Color.primaryColor(0.6),
            Color.primaryColor(0.65),
            Color.primaryColor(0.7),
            Color.primaryColor(0.75),
            Color.primaryColor(0.8),
            Color.primaryColor(0.85),
            Color.primaryColor(0.9),
            Color.primaryColor(0.95),
          ],
        },
        textStyle: {
          color: Color.blackColor(1),
        },
        show: false,
      },
      geo: {
        map: 'china',
        roam: 'move',
        zoom: 1.2,
        itemStyle: {
          areaColor: Color.f0,
          borderColor: Color.white,
        },
        emphasis: {
          itemStyle: {
            areaColor: Color.f0,
          },
          label: {
            show: false,
          },
        },
      },
      series: [{
        name: '泵机数',
        type: 'scatter',
        coordinateSystem: 'geo',
        roam: 'move',
        data: convertData(data),
        symbolSize(val: any) {
          return val[0] / 5;
        },
        label: {
          formatter: '{b}',
          show: false,
          color: Color.blackColor(1),
          fontSize: 14,
          fontFamily: 'PingFang SC',
        },
        emphasis: {
          label: {
            show: true,
            color: Color.blackColor(1),
            fontFamily: 'PingFang SC',
          },
          itemStyle: {
            borderColor: Color.white,
            borderWidth: 0,
            color: Color.white,
          },
        },
        itemStyle: {
          color: Color.blackColor(1),
        },
      },
      {
        type: 'map',
        map: 'china',
        geoIndex: 0,
        aspectScale: 0.75,
        silent: true,
        label: {
          show: false,
        },
        emphasis: {
          label: {
            show: false,
          },
        },
      },
      ],
    };

    const cityGradeOption = {
      backgroundColor: Color.white,
      tooltip: {
        trigger: 'item',
        formatter(params: any) {
          const result: any = [];
          data?.forEach(((item: any) => {
            result.push(item.name);
          }));
          if (!result.includes(params.name)) {
            return '';
          }
          return `${params.name} : ${params.value[2]}`;
        },
        textStyle: {
          fontFamily: 'PingFang SC',
        },
      },
      legend: {
        data: [],
      },
      visualMap: {
        min: 0,
        max: 300000,
        left: 20,
        bottom: 20,
        calculable: true,
        text: ['高', '低'],
        inRange: {
          color: [
            Color.primaryColor(0.5),
            Color.primaryColor(0.55),
            Color.primaryColor(0.6),
            Color.primaryColor(0.65),
            Color.primaryColor(0.7),
            Color.primaryColor(0.75),
            Color.primaryColor(0.8),
            Color.primaryColor(0.85),
            Color.primaryColor(0.9),
            Color.primaryColor(0.95),
          ],
        },
        textStyle: {
          color: Color.blackColor(1),
        },
        show: false,
      },
      geo: {
        map: 'china',
        roam: 'move',
        zoom: 1.2,
        itemStyle: {
          areaColor: Color.f0,
          borderColor: Color.white,
        },
        emphasis: {
          itemStyle: {
            areaColor: Color.f0,
          },
          label: {
            show: false,
          },
        },
      },
      series: [{
        name: '泵机数',
        type: 'scatter',
        coordinateSystem: 'geo',
        data: convertData(data),
        symbolSize(val: any) {
          return val[0] / 5;
        },
        label: {
          formatter: '{b}',
          show: false,
          color: Color.blackColor(1),
          fontSize: 14,
        },
        emphasis: {
          label: {
            show: true,
            color: Color.blackColor(1),
          },
          itemStyle: {
            borderColor: Color.white,
            borderWidth: 0,
            color: Color.white,
          },
        },
        itemStyle: {
          color: Color.primaryColor(0.65),
        },
      },
      {
        type: 'map',
        map: 'china',
        geoIndex: 0,
        aspectScale: 0.75,
        silent: true,
        label: {
          show: false,
        },
        emphasis: {
          label: {
            show: false,
          },
        },
      },
      ],
    };
    const cityRegionOption = {
      backgroundColor: Color.white,
      tooltip: {
        // show: false
        trigger: 'item',
        formatter(params: any) {
          const result = distributList?.filter((item: any) => item.name === params.name);
          if (result.length > 0) {
            const resultAmount = distributList?.filter((item: any) => item.city === result[0]?.area);
            if (resultAmount && resultAmount[0]?.amount) {
              return `
              <p>
                <span
                  style="display:inline-block;
                  width:10px;height:10px;background:${params.color};
                  border-radius:50%;margin-right:5px">
                </span>
                <span style="fontFamily: 'PingFang SC'">${result[0]?.area}</span>
                <span style="margin:0 15px"></span>
                <span style="font-family: 'Roboto'">
                  ${Number(resultAmount[0]?.amount).toLocaleString()}
                </span>
              </p>
              `;
            }
          }
          return '';
        },
      },
      title: {
        text: '全国泵机销售情况',
        left: 'center',
        textStyle: {
          color: Color.white,
        },
      },
      visualMap: {
        min: 0,
        max: 220000,
        left: 20,
        bottom: 20,
        calculable: true,
        text: ['高', '低'],
        inRange: {
          color: [
            Color.primaryColor(0.5),
            Color.primaryColor(0.55),
            Color.primaryColor(0.6),
            Color.primaryColor(0.65),
            Color.primaryColor(0.7),
            Color.primaryColor(0.75),
            Color.primaryColor(0.8),
            Color.primaryColor(0.85),
            Color.primaryColor(0.9),
            Color.primaryColor(0.95),
          ],
        },
        textStyle: {
          color: Color.blackColor(1),
        },
        show: false,
      },
      legend: {
        data: [],
      },
      geo: {
        map: 'china',
        roam: 'move',
        zoom: 1.2,
        itemStyle: {
          areaColor: Color.primaryColor(0.04),
          borderColor: Color.white,
        },
        emphasis: {
          itemStyle: {
            areaColor: Color.primary,
          },
          label: {
            show: false,
          },
        },
      },
      series: [
        {
          type: 'map',
          map: 'china',
          silent: true,
          geoIndex: 0,
          coordinateSystem: 'geo',
          aspectScale: 0.75,
          label: {
            show: false,
          },
          emphasis: {
            label: {
              show: false,
            },
            itemStyle: {
              areaColor: Color.primary,
              color: Color.white,
            },
          },
          itemStyle: {
            areaColor: Color.f0,
            borderColor: Color.white,
          },
          data: getColorchange(),
        },
      ],
      // dataset: {source: mapdata}
    };
    if (type === 'city') {
      Ttalend.setOption(option, true);
    } else if (type === 'city_grade') {
      Ttalend.setOption(cityGradeOption, true);
    } else if (type === 'city_region') {
      Ttalend.setOption(cityRegionOption, true);
    }
    Ttalend.on('mouseover', params => {
      if (type === 'city') getCurrentCity(params.name);
      else if (type === 'city_grade') getCurrentArea(params.name);
      else if (type === 'city_region') getCurrentRegion(params.name);
    });
    Ttalend.on('mouseout', params => {
      changeActive('');
    });
  };

  useEffect(() => {
    render();
    return () => { };
  }, [distributList, type]);

  return (
    <section className="company-chart-distruibution" ref={talentMap} />
  );
};

export default observer(CityMap);
